export default {
    nuevo: "Nuevo adjunto",
    pregEliminar: "¿Confirmas que deseas eliminar este adjunto?",
    titleSubir: "Subir adjunto",
    labelSeleccionar: "Click para seleccionar archivo",
    seleccionarTipo: "Seleccionar tipo",
    subir: "Subir",
    cotizacion: "Cotización",
    orden: "Orden de compra",
    certificado: "Certificado",
    factura: "Factura",
    errorTamaño: "El tamaño del archivo supera el límite de 10 MB",

}